import { render } from "./AdminNotification.vue?vue&type=template&id=6b4e4114"
import script from "./AdminNotification.vue?vue&type=script&lang=js"
export * from "./AdminNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__